/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   City objects
 */

import { Bizo, autoclass } from '../../shared/bizos/base'
import { MNeighborhood, scrub as scrubNeighborhood } from '../../shared/bizos/neighborhood'
import Pricing from '../../shared/bizos/pricing'
import { getBedroomCounts } from './helpers/bedroomCounts'

// scrub unimportant data
export const scrub = (data) => {
  if (!data) {
    return data
  }
  const scrubbedData = { ...data }
  delete scrubbedData.bounds
  if (Array.isArray(scrubbedData.neighborhoods)) {
    scrubbedData.neighborhoods = scrubbedData.neighborhoods.map(scrubNeighborhood)
  }
  return scrubbedData
}

export const MCity = autoclass(
  'MCity',
  class MCity extends Bizo {
    constructor(data = {}) {
      super(data)
      this._data = scrub(data)
    }
  },
  {
    id: 'city_id',
    box: 'box',
    cityId: 'city_id',
    country: 'country',
    encodedBounds: 'encoded_bounds',
    index: 'index',
    indexAttrs: 'index_attrs',
    indexAttrsJSON: 'index_attrs_json',
    inventoryCounts: 'inventory_counts',
    lat: 'lat',
    listUrl: 'list_url',
    listingCount: 'listing_count',
    listingCounts: 'listing_counts',
    lng: 'lng',
    mainImageUrl: 'main_image_url',
    name: 'name',
    parentId: 'parent_id',
    path: 'path',
    state: 'state',
    type: 'type',
    url: 'url',
    verticals: 'verticals_json',
    /**
     *
     * @param {import('@zcode/state-type').MCity} t
     */
    hasImage: (t) => Boolean(t._data.main_image_url),
    /**
     *
     * @param {import('@zcode/state-type').MCity} t
     */
    listingCountText: (t) => (t.listingCount ? `${t.listingCount} Listings` : undefined),
    /**
     *
     * @param {import('@zcode/state-type').MCity} t
     */
    mediumImageUrl: (t) => (t.hasImage ? `${t.mainImageUrl}.md.jpg` : t.mainImageUrl),
    /**
     *
     * @param {import('@zcode/state-type').MCity} t
     */
    smallImageUrl: (t) => (t.hasImage ? `${t.mainImageUrl}.sm.jpg` : t.mainImageUrl),
  }
)

const City = autoclass('City', class City extends MCity {}, {
  bedroomCounts: getBedroomCounts,
  createdOn: 'created_on',
  data: 'data',
  displayBounds: 'display_bounds',
  html: 'html',
  modifiedOn: 'modified_on',
  neighborhoodIds: 'neighborhood_ids',
  pricing: { name: 'pricing', type: Pricing, isArray: true },
  neighborhoods: { name: 'neighborhoods', type: MNeighborhood, isArray: true },
})
export default City
